/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/30/20 6:41 PM
 */

import React from "react";
import {IconButton, Tooltip, useTheme} from "@mui/material";
import {Brightness7 as LightThemeIcon, Brightness4 as DarkThemeIcon} from "@mui/icons-material";
import {useDispatch} from "react-redux";
import {set} from "../state/reducers/preferences";

export default function ThemeToggle() {

	const theme = useTheme();
	const dispatch = useDispatch();
	const currentTheme = theme.palette.mode;

	return (
		<Tooltip title={"Toggle " + (currentTheme === "light" ? "dark" : "light") + " theme"} placement={"right"}>
			<IconButton
				onClick={() => { dispatch(set({ theme: currentTheme === "light" ? "dark" : "light"}))}}
				sx={{ color: "#fff" }}
				size={"large"}
			>
				{currentTheme === "light" ? <DarkThemeIcon sx={{ fontSize: 26 }} /> : <LightThemeIcon sx={{ fontSize: 26 }} />}
			</IconButton>
		</Tooltip>
	);

}